import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { StyledGallerySlideProps } from './Gallery.types';

export const Slide = styled('li')<StyledGallerySlideProps>(
    ({
        allowCropping,
        maxImageDimensions,
        isScaledAlongHorizontalAxis,
        isImageLoaded = false,
        isZoomed = false
    }) => {
        const isScaledAlongVerticalAxis = !isScaledAlongHorizontalAxis;

        return css`
            position: relative;
            display: block;
            width: 100%;
            height: 100%;
            flex-shrink: 0;
            overflow: hidden;
            cursor: pointer;
            touch-action: ${isZoomed ? 'none' : 'pan-y'};

            ${!isImageLoaded &&
            `
            background: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0OHB4IiBoZWlnaHQ9IjQ4cHgiIHZpZXdCb3g9IjAgMCAxMDAgMTAwIj4KICA8Y2lyY2xlIGN4PSI1MCIgY3k9IjUwIiByPSIzMCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjODA0NkYxIiBzdHJva2Utd2lkdGg9IjgiIG9wYWNpdHk9Ii4xIi8+CiAgPGNpcmNsZSBjeD0iNTAiIGN5PSI1MCIgcj0iMzAiIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzgwNDZGMSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2Utd2lkdGg9IjgiPgogICAgPGFuaW1hdGVUcmFuc2Zvcm0gYXR0cmlidXRlTmFtZT0idHJhbnNmb3JtIiBkdXI9IjEuNDI4NTcxNDI4NTcxNDI4NHMiIGtleVRpbWVzPSIwOzAuNTsxIiByZXBlYXRDb3VudD0iaW5kZWZpbml0ZSIgdHlwZT0icm90YXRlIiB2YWx1ZXM9IjAgNTAgNTA7MTgwIDUwIDUwOzcyMCA1MCA1MCIvPgogICAgPGFuaW1hdGUgYXR0cmlidXRlTmFtZT0ic3Ryb2tlLWRhc2hhcnJheSIgZHVyPSIxLjQyODU3MTQyODU3MTQyODRzIiBrZXlUaW1lcz0iMDswLjU7MSIgcmVwZWF0Q291bnQ9ImluZGVmaW5pdGUiIHZhbHVlcz0iMTguODQ5NTU1OTIxNTM4NzYgMTY5LjY0NjAwMzI5Mzg0ODgyOzk0LjI0Nzc3OTYwNzY5MzggOTQuMjQ3Nzc5NjA3NjkzNzc7MTguODQ5NTU1OTIxNTM4NzYgMTY5LjY0NjAwMzI5Mzg0ODgyIi8+CiAgPC9jaXJjbGU+Cjwvc3ZnPg==") 50% 50% no-repeat;
            background-size: 48px 48px;
            `}
            img {
                display: block;
                position: absolute;
                top: 50%;
                left: 50%;
                width: ${isScaledAlongHorizontalAxis
                    ? '100%'
                    : allowCropping && !isImageLoaded
                    ? '100%'
                    : 'auto'};
                height: ${isScaledAlongVerticalAxis
                    ? '100%'
                    : allowCropping && !isImageLoaded
                    ? '100%'
                    : 'auto'};
                transform: translate(-50%, -50%);
                object-fit: cover;
                -webkit-tap-highlight-color: rgba(0, 0, 0, 0);

                /* Don't allow the image to be stretched larger than its own dimensions... */
                max-width: ${maxImageDimensions[0]}px;
                max-height: ${maxImageDimensions[1]}px;

                /* ... unless we specifically allow it so stretch and/or overflow the viewport */
                ${allowCropping &&
                `
                    max-width: none;
                    max-height: none;
                `};
            }
        `;
    }
);

export const SlideImageWrapper = styled('div')(css`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    transform-origin: 0 0;
`);
